import { useCallback, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
// import { RoutesEnum } from 'src/shared/models/enums/routes.enum';
import userManager from 'src/userManager';

export const SilentSignin = () => {
  // const navigate = useNavigate();
  const trySilentSigning = useCallback(async () => {
    try {
      const silentResult = await userManager.signinSilent();
      ConsoleHelper.log('Silent login success', silentResult);
    } catch (error) {
      ConsoleHelper.warn('Silent login failed', error);
      // navigate(RoutesEnum.Default, { replace: true });
      // Såhär kan man göra om man automatiskt skicka användaren till identity om den inte tidigare är inloggad
      // Osäker på funktionen dock och mindre bra UX
      // userManager.signinRedirect();
    }
  }, []);

  useEffect(() => {
    trySilentSigning();
  }, [trySilentSigning]);

  return null;
};
